import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import DataSource from '../DataSource'
import moment from 'moment'
import ToggleSimple from '../elements/ToggleSimple'
import SpeedBoostScheduleForm from './SpeedBoostScheduleForm'
import SpeedBoostAvailableBoostDays from './SpeedBoostAvailableBoostDays'
import FormSuccess from '../components/FormSuccess'
import AjaxLoader from '../components/AjaxLoader'
import ReactModal from './ReactModal'
import Button from '../elements/Button'
import Error from '../components/Error'
import ThingsToKnow from './ThingsToKnow'
import useReadableDate from '../hooks/useReadableDate'
import globals from '../globals'

const SpeedBoostModule = props => {
    const [scheduleData, setScheduleData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [isSaved, setIsSaved] = useState(false)
    const [isDeleted, setIsDeleted] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [scheduleError, setScheduleError] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)

    const thingsContainer = useRef(null)

    const currentBoostEnds = useReadableDate(scheduleData.currentBoostEnds)

    useEffect(() => {
        setScheduleData(props.serviceDetails)
    }, [props.serviceDetails])

    const handleSubmitSpeedBoostData = (data) => {
        setIsLoading(true)
        setErrorMessage(null)

        DataSource.postData(
            `/api/postSpeedBoostService/${props.serviceId}`,
            data,
            response => {
                setIsLoading(false)
                setScheduleData(prevState => ({
                    ...prevState,
                    boostStatus: 'Pending'
                }))
            },
            error => {
                setIsLoading(false)
                if (error.response.status === 422) {
                    setErrorMessage(error.response.data.errors)
                } else {
                    setErrorMessage({ error: 'Oops, something went wrong, please try again.' })
                }
            }
        )
    }

    const handleModifySchedule = (data) => {
        DataSource.postData(
            `/api/postSpeedBoostModifySchedule/${props.serviceId}`,
            {
                scheduleStartDate: formatDate(data.startDate) + ' ' + data.startTime,
                boostDays: data.boostDaysNeeded
            },
            (response) => {
                const serviceData = {
                    scheduleEnabled: true,
                    scheduledDays: data.boostDaysNeeded,
                    scheduledStartTime: data.startTime,
                    scheduleStartDate: formatDate(data.startDate) + ' ' + data.startTime,
                    scheduleEndDate: formatDate(data.endDate) + ' ' + data.startTime
                }
                setIsSaved(true)
                props.updateServiceDetails(serviceData)
            },
            error => {
                setIsSaved(false)
                if (error.response.status === 422) {
                    setScheduleError(error.response.data.errors)
                } else {
                    setScheduleError({ error: 'Oops, something went wrong, please try again.' })
                }
            }
        )
    }

    const handleDeleteSchedule = () => {
        DataSource.postData(
            `/api/postSpeedBoostDeleteSchedule/${props.serviceId}`,
            {},
            response => {
                setIsDeleted(true)
                const serviceData = {
                    scheduleEnabled: false,
                    scheduledDays: 0,
                    scheduledStartTime: null,
                    scheduleStartDate: null,
                    scheduleEndDate: null
                }
                props.updateServiceDetails(serviceData)
            },
            error => {
                setIsDeleted(false)
                if (error.response.status === 422) {
                    setScheduleError(error.response.data.errors)
                } else {
                    setScheduleError({ error: 'Oops, something went wrong, please try again.' })
                }
            }
        )
    }

    const handleSwitchChange = event => {
        event.preventDefault()
        setShowModal(false)
        const date = new Date()
        const data = {
            startDate: moment(date).format('YYYY-MM-DD HH:mm:ss'),
            boostDays: 1
        }
        handleSubmitSpeedBoostData(data)
    }

    const triggerModal = () => {
        if (scheduleData.boostStatus === 'Inactive') {
            setShowModal(true)
        }
    }

    const handleCancel = (event) => {
        event.preventDefault()
        setShowModal(false)
    }

    const formatDate = (date) => {
        return moment(date).format('YYYY-MM-DD')
    }

    const goToThingsYouKnow = () => {
        window.scrollTo({
            top: thingsContainer.current.offsetTop,
            behavior: 'smooth'
        })
    }

    const speedBoostCopy = () => {
        if (props.serviceDetails.boostSpeed === '25/10Mbps' || props.serviceDetails.boostSpeed === '25/5Mbps' || props.serviceDetails.boostSpeed === '50/20Mbps') {
            return (
                <p className='text-left font-smaller lh'>
                    Your Exetel nbn service comes with Speed Boost™ which means you can purchase Upgrade Days for just  <span className='bold color-lime'>$2/day</span>. Actual boost speeds achieved may be lower than the indicated upgrade speed tier. For more details see <a className='bold color-lime arrow-right' onClick={goToThingsYouKnow}>Things you need to know.</a>
                </p>                
            )
        }
        return (
            <p className='text-left font-smaller lh'>
                Your Exetel nbn™ service comes with <span className='bold color-lime'>upto 5 FREE Speed Upgrade Days</span> every month. Unused days rollover into your  <span className='bold color-lime'>My Speed Boost Bank™</span> to a max of 30 days. If you need more, you can purchase additional <span className='bold color-lime'>Upgrade Days</span> of just $2/day. Actual boost speeds achieved my be lower than the indicated upgrade speed tier. For more detail see <a className='bold color-lime arrow-right' onClick={goToThingsYouKnow}>Things you need to know.</a>
            </p>
        )
    }

    return (
        <div>
            <div className='speed-boost-module module'>
                <Heading title='Activate Boost' />
                <div className='p-md-4 p2'>
                    <div className='boost-me-setion'>
                        <div className='row px-lg-5 px-2'>
                            <div className='col-12'>
                                <div className='sb-info-wrapper'>
                                    <div className='mehul-container mt-4 mb-4 row align-items-center'>
                                        <div className='col-12 col-md-6 col-lg-6 text-lg-right text-center pr-lg-5'>
                                            <img src='/images/MyExetel-SpeedBoost.svg' alt='MyExetel SpeedBoost' className='speed-boost-img-myexetel' />
                                        </div>
                                        <div className='title col-12 col-lg-6 col-md-6'>
                                            <div className='text-md-left text-center color-indigo'>
                                                <p className='font-large bold'>
                                                    Boost here for 24-hour <br />upgrade to {scheduleData.boostSpeed}.
                                                </p>
                                            </div>
                                            <div className='text-md-left text-center mt-3'>
                                                <p className='font-small lh'>
                                                    <span dangerouslySetInnerHTML={{ __html: globals.noWidows(`The average activation time over the past 12 hours is ${props.serviceDetails.averageBoostTime}.`) }} />
                                                </p>
                                            </div>
                                            <div className='mt-5 text-md-left text-center'>
                                                {isLoading
                                                    ? <AjaxLoader className='text-left' width='60px' />
                                                    : <ToggleSimple value={scheduleData.boostStatus !== 'Inactive'} handleChange={triggerModal} className={`mehul-speedboost-switch ${scheduleData.boostStatus === 'Pending' ? 'pending-switch' : ''}`} />}
                                            </div>
                                            {scheduleData.boostStatus === 'Active' && <div className='mt-3'><FormSuccess message={`${scheduleData.boostSpeed} speed boost active until ${currentBoostEnds}.`} icon={false} /></div>}
                                            {scheduleData.boostStatus === 'Pending' && <div className='pending-form mt-3'>We'll notify you when your Speed Boost is active.</div>}
                                            {errorMessage && <div className='mt-3'><Error errors={errorMessage} /></div>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row px-2 px-lg-5 mt-3'>
                                    <div className='col-12 px-3 m-auto'>
                                        {speedBoostCopy()}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row px-md-5 p-3'>
                            <div className='col-md-6 mb-5 mb-lg-0'>
                                <div className='sb-info-wrapper h-100 pb-4'>
                                    <SpeedBoostScheduleForm scheduleData={scheduleData} onSubmitData={handleModifySchedule} onDeleteSchedule={handleDeleteSchedule} isSaved={isSaved} isDeleted={isDeleted} scheduleError={scheduleError} />
                                    {scheduleData.scheduleEnabled && !isDeleted && <div className='mt-3'><FormSuccess message='Your Speed Boost schedule is enabled.' icon={false} /></div>}
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='sb-info-wrapper h-100'>
                                    <SpeedBoostAvailableBoostDays scheduleData={scheduleData} boostDaysRate='$2/day' />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <ReactModal showModal={showModal} handleCloseModal={() => setShowModal(false)} heading='Just checking'>
                    <div className='row'>
                        <div className='col-12 text-center'>
                            <p className='mt-0 mb-4 lh'>Please confirm you would like to activate your Speed Boost?</p>
                            <div className='d-flex justify-content-center'>
                                <Button title='Confirm' action={handleSwitchChange} className='mr-3' />
                                <Button title='Cancel' action={event => handleCancel(event)} color='red' />
                            </div>
                        </div>
                        {props.children}
                    </div>
                </ReactModal>
            </div>
            <div className='mt-5' ref={thingsContainer}>
            {props.serviceDetails.businessBoost
                ? <ThingsToKnow type='speedBoostSmb' />
                : <ThingsToKnow type='speedBoost' />
            }

            </div>
        </div>
    )
}

SpeedBoostModule.propTypes = {
    serviceDetails: PropTypes.object.isRequired,
    serviceId: PropTypes.number.isRequired,
    updateServiceDetails: PropTypes.func
}

export default SpeedBoostModule



// WEBPACK FOOTER //
// ./resources/js/modules/SpeedBoostModule.js